export enum RespTypes {
  Default = 'default',
  ImageLeftAndTextRight = 'image-left-text-right',
  ImagesPlusPopup = 'images-plus-popup',
}
